<script lang="ts">
  import { dev } from '$app/environment';
  import { onMount } from 'svelte';

  export let width: string | undefined = undefined;
  export let height: string | undefined = undefined;
  export let adSlot: string;
  export let horizontal = false;
  export let margin: string | undefined = 'var(--space-4) auto';

  let ref: HTMLElement;

  onMount(() => {
    if (dev) {
      console.log('adsbygoogle.push({})', ref);
      ref.style.backgroundImage = 'linear-gradient(45deg, orange, yellow)';
      ref.textContent = ref.dataset['adSlot'] ?? null;
    }
    (window as any).adsbygoogle?.push({});
  });
</script>

{#if horizontal}
  <div class="horizontal-ad-wrapper" style="margin:{margin}">
    <ins
      bind:this={ref}
      class="adsbygoogle"
      style="display:block; width:100%; height:{height ?? '90px'}"
      data-ad-client="ca-pub-9791938802380372"
      data-ad-slot={adSlot}
    />
  </div>
{:else}
  <ins
    bind:this={ref}
    class="adsbygoogle"
    style="display:inline-block; width:{width}; height:{height}"
    data-ad-client="ca-pub-9791938802380372"
    data-ad-slot={adSlot}
  />
{/if}

<style lang="postcss">
  .horizontal-ad-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 90vw;
    overflow: hidden;

    @media (--sm) {
      width: 70rem;
    }
  }
</style>
